<template>
  <div class="reportSearchPage">
    <Card class="reportListCard">
      <Form>
        <Row :gutter="24" class="row">
          <Col :span="4">
            <Select showArrow :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear mode="multiple" placeholder="全部诊断中心" v-model="searchItem.diagnosis" @inputKeydown="inputKeydown">
              <Option v-for="val in diagnosisList" :key="val.id" :value="val.id">{{val.name}}</Option>
            </Select>
          </Col>
          <Col :span="4">
            <Select showArrow :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear mode="multiple" placeholder="全部设备类型" v-model="searchItem.device" @inputKeydown="inputKeydown">
              <Option v-for="val in deviceList" :key="val.device_category_id" :value="val.device_category_id">{{val.device_category_name}}</Option>
            </Select>
          </Col>
          <Col :span="4">
            <Select showArrow :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear mode="multiple" placeholder="全部检查医院" v-model="searchItem.checkHospital" @inputKeydown="inputKeydown">
              <Option v-for="val in checkHospitalList" :key="val.hospital_id" :value="val.hospital_id">{{val.hospital_name}}</Option>
            </Select>
          </Col>
          <Col :span="4">
            <Select showArrow :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear mode="multiple" placeholder="全部编写医生" v-model="searchItem.writeDoctor" @inputKeydown="inputKeydown">
              <Option v-for="val in writeDoctorList" :key="val.id" :value="val.id">{{val.user_name}}</Option>
            </Select>
          </Col>
          <Col :span="4">
            <Select showArrow :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear mode="multiple" placeholder="全部报告类型" v-model="searchItem.reportType" @inputKeydown="inputKeydown">
              <Option v-for="val in searchItem.reportTypeList" :key="val.id" :value="val.id">{{val.name}}</Option>
            </Select>
          </Col>
          <Col showArrow :span="4">
            <Select showArrow :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear mode="multiple" placeholder="全部报告状态" v-model="searchItem.reportStatus" @inputKeydown="inputKeydown">
              <Option v-for="val in searchItem.reportStatusList" :key="val.id" :value="val.id">{{val.name}}</Option>
            </Select>
          </Col>
        </Row>
        <Row :gutter="24" class="row">
          <Col :span="4">
            <Select :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear v-model="searchItem.dateType" placeholder="请选择日期类型">
              <Option v-for="val in searchItem.dateTypeList" :key="val.id" :value="val.id">{{val.name}}</Option>
            </Select>
          </Col>
          <Col :span="8">
            <RangePicker :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.startAEndTime"></RangePicker>
          </Col>
          <Col :span="6">
            <Input type="text" placeholder="请输入报告单号/姓名/检查部位/报告关键字" v-model.trim="searchItem.nameOrBody"></Input>
          </Col>
          <Col :span="6">
            <div class="search">
              <Button class="clear" @click="clearSearchData">清空</Button>
              <Button type="primary" @click="searchReport">搜索</Button>
            </div>
          </Col>
        </Row>
      </Form>
      <Row :gutter="24" class="tableRow">
        <Table
          :dataSource="dataList"
          :columns="columns"
          :pagination='false'
          :rowKey="record => record.id + ''"
          :rowClassName="rowClassName"
          :customRow="customRow"
        >
          <template slot="createDate" slot-scope="text, record">
            <p v-if="record.report_stage.toString() === '1'" style="color: #333">{{record.created_date}}</p>
            <p v-else-if="record.report_stage.toString() === '5'" style="color: #f68326">{{record.created_date}}</p>
            <p v-else-if="record.report_stage.toString() === '10'" style="color: #f62626">{{record.created_date}}</p>
          </template>
          <template slot="patientMsg" slot-scope="text, record">
            <p>{{record.patient_name}} ({{record.sex === 1 ? '男' : '女'}}) ({{record.age}}{{record.age_unit|getAgeUnit}})</p>
            <p>{{record.report_code}}</p>
          </template>
          <template slot="hospitalAndDevice" slot-scope="text, record">
            <p>{{record.hospital_name}}</p>
            <p>{{record.device_category_name}}</p>
          </template>
          <template slot="reportCategory" slot-scope="text, record">
            {{record.report_category|reportType}}
          </template>
          <template slot="checkBody" slot-scope="text, record">
            {{record.check_item_name || record.check_item_selected_name}}
          </template>
          <template slot="reportStatus" slot-scope="text, record">
            <span v-if="dataSource.pageFlag && record.status_detail !== 0">{{record.status_detail|preProcessingStatus}}</span>
            <span v-else-if="record.status === 0 && record.status_detail === 0">待运算</span>
            <span v-else-if="record.status === 0 && record.status_detail !== 0">{{record.status_detail|preProcessingStatus}}</span>
            <span v-else-if="record.status !== 0 && record.status_detail === 0">{{record.status|reportStatus}}</span>
            <span v-else>{{record.status|reportStatus}}</span>
          </template>
        </Table>
      </Row>
      <Row>
        <div class="page">
          <slot name="static"></slot>
          <Pagination
            v-model="pageNo"
            :defaultPageSize="pageSize"
            showQuickJumper
            :total="totalCount"
            @change="changePage"
          />
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import { setSession, getSession } from '../../libs/utils'
import { Table, Row, Card, Col, Select, DatePicker, Input, Button, Form, Pagination } from 'ant-design-vue'
import { mapState } from 'vuex'
import { fixTableHeader } from '../../libs/mixin'
import moment from 'moment'
import { getAiCheckImageCenterId } from '../../config'
export default {
  mixins: [fixTableHeader],
  components: {
    Table,
    Row,
    Card,
    Col,
    Select,
    Option: Select.Option,
    RangePicker: DatePicker.RangePicker,
    Input,
    Button,
    Form,
    Pagination
  },
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return []
      }
    },
    totalCount: {
      type: Number,
      default: 0
    },
    activeId: {
      type: Number,
      default: () => {
        return null
      }
    },
    writeDoctorList: {
      type: Array,
      default: () => []
    },
    diagnosisList: {
      type: Array,
      default: () => []
    },
    deviceList: {
      type: Array,
      default: () => []
    },
    checkHospitalList: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageNumber: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      searchItem: {
        nameOrBody: '',
        diagnosis: undefined,
        startAEndTime: null,
        device: undefined,
        checkHospital: undefined,
        writeDoctor: undefined,
        reportType: undefined,
        reportTypeList: [
          { id: 1, name: '常规报告' },
          { id: 5, name: 'AI算法报告' },
          { id: 10, name: '自动后处理报告' },
          { id: 15, name: '半自动后处理报告' },
        ],
        reportStatus: undefined,
        reportStatusList: [
          { id: 1, name: '待编写' },
          { id: 10, name: '编写中' },
          { id: 20, name: '待审核' },
          { id: 30, name: '审核中' },
          { id: 100, name: '已完成' },
          { id: -99, name: '已取消' },
        ],
        dateTypeList: [
          { id: 1, name: '发起日期'},
          { id: 2, name: '完成日期'}
        ],
        dateType: 1,
      },
      columns: [
        {
          title: '发起时间',
          key: 'createDate',
          dataIndex: 'createDate',
          scopedSlots: { customRender: 'createDate' },
          width: 150
        },
        {
          title: '患者信息',
          key: 'patientMsg',
          dataIndex: 'patientMsg',
          scopedSlots: { customRender: 'patientMsg' },
          width: 200
        },
        {
          title: '检查医院/设备类型',
          key: 'hospitalAndDevice',
          dataIndex: 'hospitalAndDevice',
          scopedSlots: { customRender: 'hospitalAndDevice' },
          width: 200
        },
        {
          title: '影像号',
          key: 'matched_film_no',
          dataIndex: 'matched_film_no',
          width: 200
        },
        {
          title: '检查部位',
          key: 'checkBody',
          dataIndex: 'checkBody',
          scopedSlots: { customRender: 'checkBody' },
          width: 200,
        },
        {
          title: '类型',
          key: 'reportCategory',
          dataIndex: 'reportCategory',
          scopedSlots: { customRender: 'reportCategory' },
          width: 100
        },
        {
          title: 'AI算法',
          key: 'base_element_name',
          dataIndex: 'base_element_name',
          width: 150
        },
        {
          title: '状态',
          key: 'reportStatus',
          dataIndex: 'reportStatus',
          scopedSlots: { customRender: 'reportStatus' },
          width: 100
        }
      ],
      handleRowId: null,
      pageNo: this.pageNumber
    }
  },
  computed: {
    ...mapState({
      devices: state => state.app.devices,
      currentCenterId: state => state.app.currentCenterId,
    }),
    dataList() {
      let arr = []
      const aiCenterId = getAiCheckImageCenterId()
      for (let i = 0; i < this.dataSource.length; i++) {
        const item = this.dataSource[i]
        if (item.hospital_medical_image_center_id == aiCenterId && item.report_category == 1) continue
        arr.push(item)
      }
      return arr
    }
  },
  methods: {
    // 选中样式
    rowClassName (record) {
      return this.handleRowId === record.id ? 'clickRowStyle' : ''
    },
    // 选中其中一项
    customRow (record, index) {
      return {
        on: {
          click: () => {
            this.selectItem(record, index)
            this.handleRowId = record.id
          }
        }
      }
    },
    // 分页
    changePage (page) {
      this.pageNo = page
      this.$emit('pageData', { pageNo: page })
    },
    // 传递选中其中一项的数据
    selectItem (record, index) {
      this.$emit('selectItemData', {data: record, listIndex: index})
    },
    // 传递搜索条件的参数
    searchReport () {
      this.pageNo = 1
      let object = {
        nameOrBody: this.searchItem.nameOrBody,
        diagnosis: this.searchItem.diagnosis,
        startAEndTime: this.searchItem.startAEndTime,
        device: this.searchItem.device,
        checkHospital: this.searchItem.checkHospital,
        writeDoctor: this.searchItem.writeDoctor,
        reportType: this.searchItem.reportType,
        reportStatus: this.searchItem.reportStatus,
        dateType: this.searchItem.dateType
      }
      setSession('searchReportData', object)
      this.$emit('searchReportData', object)
    },
    // 清空搜索条件
    clearSearchData () {
      Object.assign(this.searchItem, {
        nameOrBody: '',
        diagnosis: undefined,
        startAEndTime: null,
        device: undefined,
        checkHospital: undefined,
        writeDoctor: undefined,
        reportType: undefined,
        reportStatus: undefined,
        dateType: 1
      })
      setSession('searchReportData', {})
    },
    inputKeydown (e) {
      e.preventDefault()
      return false
    }
  },
  watch: {
    activeId (newVal) {
      if (newVal) this.handleRowId = newVal
    }
  },
  async mounted () {
    let searchData = getSession('searchReportData', 'object') || null
    if (searchData) {
      Object.assign(this.searchItem,{
        nameOrBody: searchData.nameOrBody || '',
        diagnosis: searchData.diagnosis || undefined,
        startAEndTime: searchData.startAEndTime && searchData.startAEndTime.length > 0 ? [moment(searchData.startAEndTime[0]), moment(searchData.startAEndTime[1])] : [],
        device: searchData.device || undefined,
        checkHospital: searchData.checkHospital || undefined,
        writeDoctor: searchData.writeDoctor || undefined,
        reportType: searchData.reportType || undefined,
        reportStatus: searchData.reportStatus || undefined,
        dateType: searchData.dateType || 1
      })
    }
    this.handleTableScroll('.tableRow')

  },
  beforeDestroy () {
    this.removeHandleListener()
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.reportSearchPage{
  overflow: auto;
  .ant-select-selection--multiple .ant-select-selection__rendered {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-selection__rendered ul {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-selection__choice {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-search--inline {
    float: none;
    position: absolute;
  }
  .ant-select-selection--multiple {
    max-height: 32px;
    overflow: hidden;
  }
  .search{
    text-align: right;
    .clear{
      margin-right: @LeaveDistance;
    }
  }
  .ant-form-item {
    display: flex;
  }
  .ant-calendar-picker{
    width: 100% !important;
  }
  .ant-form-item-control-wrapper {
    flex: 1;
  }
  .row{
    margin-bottom: @LeaveDistance;
    .ant-col-4{
      padding-left: 0 !important;
      padding-right: @LeaveDistance !important;
    }
    .ant-col-6{
      padding-left: 0 !important;
      padding-right: @LeaveDistance !important;
    }
    .ant-col-8{
      padding-left: 0 !important;
      padding-right: @LeaveDistance !important;
    }
  }
  .tableRow{
    height: calc(100vh - 304px);
    overflow: auto;
    .clickRowStyle{
      background: @primaryColor;
      z-index: 10;
      color: #fff;
      td{
        border-bottom:none;
      }
      box-shadow: 0px 4px 10px #1173ce;
    }
    .ant-table-tbody>.clickRowStyle:hover>td {
      background: @primaryColor;
      color: #fff;
      border-bottom:none;
    }
    .ant-table-placeholder{
      border-bottom: none;
    }
    margin-bottom: @LeaveDistance;
  }
  .page{
    text-align: right;
  }
  .reportListCard .ant-card-body{
    padding-top: 0;
  }
  .ant-card-wider-padding .ant-card-body{
    padding: 12px;
    padding-top: 0;
    margin-left: @LeaveDistance;
  }
  .ant-card-bordered{
    border: none;
  }
}
</style>